import { render, staticRenderFns } from "./goodsDetail.vue?vue&type=template&id=fdf6506e&scoped=true&"
import script from "./goodsDetail.vue?vue&type=script&lang=js&"
export * from "./goodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./goodsDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./goodsDetail.vue?vue&type=style&index=1&id=fdf6506e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf6506e",
  null
  
)

export default component.exports